import { createFileRoute } from "@tanstack/react-router";

import { AdminInvoicesTab, invoicesSearchSchema } from "@/features/billing";

export const Route = createFileRoute(
  "/_auth/_app-shell/billing/accounts/$projectId/invoices",
)({
  component: RouteComponent,
  validateSearch: invoicesSearchSchema,
});

function RouteComponent() {
  const { projectId } = Route.useParams();
  const { limit, page } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <AdminInvoicesTab
      limit={limit}
      onLimitChange={(nextLimit) =>
        navigate({ search: (prev) => ({ ...prev, limit: nextLimit, page: 1 }) })
      }
      onPageChange={(nextPage) =>
        navigate({ search: (prev) => ({ ...prev, page: nextPage }) })
      }
      page={page}
      projectId={Number(projectId)}
    />
  );
}
